import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconReceiptionBell: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconReceiptionBell"><Path d="M12.752 4.5V6.03193C17.4374 6.43365 21.002 10.5874 21.002 16.2891V18H12.752V19.5H21V21H3V19.5H11.252V18H3.00195V16.2891C3.00195 10.5874 6.56654 6.43365 11.252 6.03193V4.5H9.00195V3H15.002V4.5H12.752Z" fill="currentColor"/></CentralIconBase>;
});

export default IconReceiptionBell;
